<!-- eslint-disable -->
<template lang="pug">
    svg(:width="elemWidth" height="25" xmlns="http://www.w3.org/2000/svg")
        line(x1="0.5" y1="0.5" :x2="elemWidth" y2="0.5" stroke="black")
        line(:x1="elemWidth - 0.5" y1="25" :x2="elemWidth - 0.5" y2="1" stroke="black")

</template>

<script>
/*eslint-disable*/

export default {
    props: {
        elemWidth: {
            type: Number,
            default: 60,
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
